module.exports = __webpack_public_path__ + "img/ai.d9e74e95.png";